var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-badge',{attrs:{"value":_vm.value,"is-dot":_vm.isDot}})
}
var staticRenderFns = []

export { render, staticRenderFns }